import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';



import SAISVG from '../../../_template/helpers/CommonFunction'

const CredentialPopup = (props) => {
    const {title, username, password} = props;

    const [ isChangeIcon, setIsChangeIcon ] = useState({
        click_username : false,
        click_password : false
    });

    const copyHandler = async (type) => {
        if( type === 'user_name' ){
            await navigator.clipboard.writeText(username);
            setIsChangeIcon({click_username : true})
        }
        if( type === 'password' ){
            await navigator.clipboard.writeText(password);
            setIsChangeIcon({click_password : true})
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setIsChangeIcon({click_username : false})
            setIsChangeIcon({click_password : false})
        }, 2000);
    },[isChangeIcon])


    return (
        <>
            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-250px' data-sai-menu='true'>
                <div className="row p-5">
                    <div className="col-md-12 mb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="mb-5 fs-4">
                                    { title }
                                </h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10">
                                <div className="d-flex align-items-center me-3 me-xl-13">
                                    <div className="me-2">
                                        <div className="fw-bold fs-1">
                                            <SAISVG path="media/icons/duotune/general/gen049.svg" className="svg-icon-muted svg-icon-2hx" />
                                        </div>
                                    </div>
                                    <div className="m-0">
                                        <span className="fw-semibold text-gray-400 d-block fs-8">Username</span>
                                        <a href="#" className="fw-bold text-gray-800 fs-7">
                                            {username}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 m-auto">
                                { isChangeIcon.click_username ? 
                                    <FontAwesomeIcon className='fs-2 text-primary' icon={faCheck} /> : 
                                    <div className='cursor-pointer' onClick={() => copyHandler('user_name')}>
                                        <FontAwesomeIcon className='fs-2 text-primary' icon={faCopy} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-10">
                                <div className="d-flex align-items-center me-3 me-xl-13">
                                    <div className="me-2">
                                        <div className="fw-bold fs-1">
                                            <SAISVG path="media/icons/duotune/general/gen051.svg" className="svg-icon-muted svg-icon-2hx" />
                                        </div>
                                    </div>
                                    <div className="m-0">
                                        <span className="fw-semibold text-gray-400 d-block fs-8">Password</span>
                                        <a href="#" className="fw-bold text-gray-800 fs-7">
                                            {password}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2 m-auto">
                                { isChangeIcon.click_password ? 
                                    <FontAwesomeIcon className='fs-2 text-primary' icon={faCheck} /> : 
                                    <div className='cursor-pointer' onClick={() => copyHandler('password')}>
                                        <FontAwesomeIcon className='fs-2 text-primary' icon={faCopy} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CredentialPopup